// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nO8UHXVgYNoe0kiv5fBb {
  margin-top: 2rem;
}

.ToNoJ4dd_5PTdZQq49zE {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 1rem;
}
.ToNoJ4dd_5PTdZQq49zE > div {
  padding: 0.25rem 0.5rem;
  display: flex;
  gap: 0.25rem;
  align-items: center;
  justify-content: flex-start;
}
.ToNoJ4dd_5PTdZQq49zE > div:not(:nth-child(3n)) {
  border-right: 1px solid #dedede;
}
.ToNoJ4dd_5PTdZQq49zE > div:not(:nth-child(3n+1)) {
  padding-left: 2rem;
}

.UNJxq07e9jsDzE_Dqfrx {
  display: flex;
  flex-direction: column;
}
.UNJxq07e9jsDzE_Dqfrx .dnzCZGKcAauLYdmis3CA {
  height: 1rem;
  border-left: 1px solid #e3e5e5;
  border-right: 1px solid #e3e5e5;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/rlcloudsandbox/static/rlcscloudsandboxapk.module.scss"],"names":[],"mappings":"AACA;EACE,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,qCAAA;EACA,aAAA;AAAF;AAEE;EACE,uBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;AAAJ;AAEI;EACE,+BAAA;AAAN;AAGI;EACE,kBAAA;AADN;;AAMA;EACE,aAAA;EACA,sBAAA;AAHF;AAKE;EACE,YAAA;EACA,8BAAA;EACA,+BAAA;AAHJ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.apk_accordion_group {\n  margin-top: 2rem;\n}\n\n.apk_details_grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  row-gap: 1rem;\n\n  > div {\n    padding: 0.25rem 0.5rem;\n    display: flex;\n    gap: 0.25rem;\n    align-items: center;\n    justify-content: flex-start;\n\n    &:not(:nth-child(3n)) {\n      border-right: 1px solid $border-color-default;\n    }\n\n    &:not(:nth-child(3n + 1)) {\n      padding-left: 2rem;\n    }\n  }\n}\n\n.certificate_tables {\n  display: flex;\n  flex-direction: column;\n\n  .table_divider {\n    height: 1rem;\n    border-left: 1px solid #e3e5e5;\n    border-right: 1px solid #e3e5e5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"apk_accordion_group": `nO8UHXVgYNoe0kiv5fBb`,
	"apk_details_grid": `ToNoJ4dd_5PTdZQq49zE`,
	"certificate_tables": `UNJxq07e9jsDzE_Dqfrx`,
	"table_divider": `dnzCZGKcAauLYdmis3CA`
};
export default ___CSS_LOADER_EXPORT___;
